(function($) {
  $(document).ready(function () {

    initURLTarget(); // Initialise les data-url_target cliquables

    // Header
    // --------------------------------------------

    // Megamenu au survol
    $(".header__inline-menu details").hover(function (e) {
      $(this).attr("open", true);
      $(this).find(".header__submenu").mouseleave(function (e) {
        $(this).parent().removeAttr("open");
      });
    }, function (e) {
      $(this).attr("open", false);
    });

    $(".medias_grid a").hover(function (e) {
      var data_media_title = $(this).data("media-name");
      $(this).parents(".medias_grid").siblings(".grid_medias_title").html(data_media_title);
    }, function (e) {
      var data_title = $(this).parents(".medias_grid").siblings(".grid_medias_title");
      var data_initial_title = $(this).parents(".medias_grid").siblings(".grid_medias_title").data("title");
      $(data_title).html(data_initial_title);
    });

    if ($(window).width() <= 749) {
      $(document).on('click', '.menu-drawer__navigation_level_1 > div, .menu-drawer__navigation_level_1 > a', function () {
        var levels = $(".menu-drawer__navigation_level_1 > div, .menu-drawer__navigation_level_1 > a");
        var level = $(this).data("level");
        $(levels).removeClass("active");
        $(this).toggleClass("active");
        if (level) {
          $(".menu-drawer_push_links > div, .menu-drawer__navigation_level_2 > div, .nav_levels_2 > div").hide();
          $(".menu-drawer_push_links > div[data-target='"+ level +"'], .menu-drawer__navigation_level_2 > div[data-target='"+ level +"']").css("display", "flex");
          $(".menu-drawer_push_links > div[data-target='"+ level +"'], .menu-drawer__navigation_level_2 > div[data-target='"+ level +"']").css("display", "flex");
          $(".nav_levels_2 > div[data-target='"+ level +"']").show();
        }
      });

      $(document).on('click', '.menu-drawer__navigation_level_2 > * > div, .menu-drawer__navigation_level_2 > * > a', function () {
        var level = $(this).data("level");
        var level_parent = $(this).parent("div").data("target");
        var levels = $(".menu-drawer__navigation_level_2 > *[data-target='"+ level_parent +"'] > a, .menu-drawer__navigation_level_2 > *[data-target='"+ level_parent +"'] > div");
        $(levels).removeClass("active");
        $(this).toggleClass("active");
        if (level) {
          $(".nav_levels_2 > div[data-target='"+ level_parent +"'] > div").hide();
          $(".nav_levels_2 > div[data-target='"+ level_parent +"'] > div[data-target='"+ level +"']").show();
        }
      });
    }

    // Footer
    // --------------------------------------------
    // Accordeon footer mobile
    if ($(window).width() <= 749) {

      $(document).on('click', '.footer_level_1 > li', function () {
        var title = $(".footer_level_1 > li");
        var content = $(".footer_level_2");
        $(this).find(".link_level_1").toggleClass("opened");
        if (content.length) {
          $(title).not($(this)).find(".link_level_1").removeClass("opened");
          $(title).not($(this)).find(content).slideUp();
          $(this).find(content).slideToggle();
        }
      });
    }


    // Homepage
    // --------------------------------------------
    // Section images : ouverture du lien au clic sur l'image
    if ($(".section-images .column, .section-medias .column").length) {
      $(document).on('click', '.section-images .content, .section-medias .content', function () {
        var redirect = $(this).find("a").attr("href");
        if (redirect) {
          window.location.href = redirect;
        }
      });
    }

    if ($(".op").length) {
      $(document).on('click', '.op', function () {
        var redirect = $(this).data("target");
        if (redirect) {
          window.location.href = redirect;
        }
      });
    }

    if ($(".elx-banner").length) {
      $(document).on('click', '.elx-banner', function () {
        var redirect = $(this).data("target");
        if (redirect) {
          window.location.href = redirect;
        }
      });
    }
    if ($(".elx-images-list").length) {
      $(document).on('click', '.elx-images-list .grid__item', function () {
        var redirect = $(this).data("target");
        if (redirect) {
          window.location.href = redirect;
        }
      });
    }
    if ($(".section-featured-collection").length) {
      $(document).on('click', '.card__inner', function () {
        var redirect = $(this).data("target");
        if (redirect) {
          window.location.href = redirect;
        }
      });
    }

    $(document).on('click', '.see_more_btn', function () {
      $(this)
        .closest('.multicolumn')
        .find('.multicolumn-list__item.hide_on_mobile')
        .toggleClass('hide_on_mobile');
    });

    $(".search__input.field__input").on('input', function () {
    // si l'input est vide, on affiche les suggestions
      if ($(this).val() == "") {
        $(".suggestions_block").show();
      } else {
        $(".suggestions_block").hide();
      }
    });

      // Switch section liste de collections
      $(document).on('click', 'nav.collections_nav h2', function (event) {
          var $name = $(this).data("name");
          $("nav.collections_nav h2").removeClass("selected");
          $(this).addClass("selected");
          $(".section-collections-list .collection > slider-component").hide();
          $(".section-collections-list .collection > .collection__view-all").hide();
          $(".section-collections-list .collection > slider-component[data-target="+$name+"]").css("display", "block");
          $(".section-collections-list .collection > .collection__view-all[data-target="+$name+"]").css("display", "block");
        }
      );

      $(document).on('click', '#show_more_in_collection', function (event) {
          $(this).siblings(".slider-mobile-gutter").find(".full_collection_grid").toggleClass("show_all");
          $(this).find(".more").toggleClass("hide");
          $(this).find(".less").toggleClass("show");
        }
      );

    // PLP
    // --------------------------------------------

    // Au clic sur .mobile-facets__inner .icon-close on ferme le panneau de filtres
    $(document).on('click', '.mobile-facets__inner .icon-close', function () {
      $(".mobile-facets__close").trigger("click");
    });

    // Au clic sur #search-icon on ajoute la classe overflow-hidden-modal-opened à body
    $(document).on('click', '#search-icon', function () {
      $("body").toggleClass("overflow-hidden-modal-opened");
    });

    /* $(document).on('click', '.modal__close-button', function () {
      $("body").removeClass("overflow-hidden-modal-opened");
    }); */

    var searchDetails = document.querySelector('.header__search details');
    if (searchDetails) {
      searchDetails.addEventListener('toggle', function () {
        if (!this.open) {
          $("body").removeClass("overflow-hidden-modal-opened");
        }
      });
    }

    // Accordeon filtres mobile
    if ($(window).width() <= 749) {
      $(document).on('click', '.mobile-facets__details > .mobile-facets__summary', function () {
        var title = $(".mobile-facets__details > .mobile-facets__summary");
        var content = $(".mobile-facets__submenu");
        if (content.length) {
          $(title).not($(this)).next(content).slideUp();
          $(this).next(content).slideToggle();
        }
      });
    }

    // Redirection au clic sur l'image des cards
    $(document).on('click', '.card__media, .swiper-wrapper, .multicolumn-list__item', function () {
      var redirect = $(this).data("target");
      if (redirect) {
        window.location.href = redirect;
      }
    });

    // PDP
    // --------------------------------------------

    // Fadeout la barre d'achat quand le scroll est en bas de la page
    $(document).on("scroll", function (e) {
      if ($('.footer__localization').isInViewport()) {
        $(".product-sticky-bar").fadeOut();
      } else {
        $(".product-sticky-bar").fadeIn();
      }
    });

    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    // Ouverture guide des tailles
    $(document).on('click', '#ProductPopup-traceability', function () {
      var src = $("#PopupModal-traceability iframe").data("src");
      $("#PopupModal-traceability iframe").attr("src", src);
    });

    // Ouverture guide des tailles
    $(document).on('click', '#sizing, #sizing .close', function () {
      $("#sizing, #overlay").fadeOut();
    });

    $(document).on('click', '.sizing_btn', function () {
      $("#sizing, #overlay").fadeIn();
    });

    // Ouverture et Fermture PLus de couleurs
    $(document).on('click', '.associated_products .show_more_colors', function () {
      $("body").addClass("overflow-hidden");
      $("#drawer_other_colors.drawer").addClass("active");
    });

    $(document).on('click', '#drawer_other_colors.drawer .icon-close, #drawer_other_colors.drawer', function () {
      $("#drawer_other_colors.drawer").removeClass("active");
      setTimeout(() => {
        $("body").removeClass("overflow-hidden");
      }, 800);
    });

    // Ouverture et Fermture détails produit
    $(document).on('click', '#drawer_product_details.drawer .icon-close, #drawer_product_details.drawer', function () {
      $("#drawer_product_details.drawer").removeClass("active");
      $("#drawer_product_details .product_accordeon > p").removeClass("active");
      setTimeout(() => {
        $("body").removeClass("overflow-hidden");
      }, 800);
    });

    $(document).on('click', '.accordeon_product_details .tabs p', function () {
      var selected_tab = $(this).data("title");
      $("body").addClass("overflow-hidden");
      $("#drawer_product_details.drawer").addClass("active");
      $("#drawer_product_details .product_accordeon > p[data-target='" + selected_tab + "']").addClass("active");
    });

    // Ouverture onglets popin détails produit
    $(document).on('click', '.product_accordeon > p', function () {
      $("#drawer_product_details .product_accordeon > p").not(this).removeClass("active");
      $(this).toggleClass("active");
    });

    // Fermeture panier
    $(document).on('click', '#cart_drawer', function () {
      $("#cart_drawer").removeClass("active");
      $("body").removeClass("overflow-hidden");
    });

    // Fermeture des popins au clic en dehors de la popin
    $(document).on('click', '#sizing_content, .drawer_wrapper_inner, .cart-drawer', function (event) {
      event.stopPropagation();
    });

    // Voir le look
    // Fermeture popin
    $(document).on('click', '.look .close', function () {
      $(".look").removeClass("active");
    });


    $(window).on('keyup', function () {
      $(".look").removeClass("active");
    });

    // Ouverture popin
    $(document).on('click', '.see_look', function () {
      $(".look").addClass("active");
    });

    $(document).on('click', '.section-stl .grid__item > img, .icon-plus', function () {
      if ($(window).width() >= 750) {
        var stl_img_height = $(this).siblings(".look").find(".img_look img").height();
        $(this).siblings(".look").css("top", 'calc(50% - ' + stl_img_height / 2 + 'px)');
        $(this).siblings(".look").find(".products_look").height(stl_img_height);
      }
      $(this).siblings(".look").addClass("active");
    });


    // Fermeture popin après ajout au panier
    $(document).on('click', '.look .quick-add__submit', function () {
      setTimeout(() => {
      $(".look").removeClass("active");
      }, 1000);
    });

    // position popin au scroll si bandeau d'annonce présent
    if ($(window).width() >= 750) {
      $(document).on("scroll", function (e) {
        if ($('.announcement-bar-section').length) {
          var menu_height = $(".section-header").innerHeight();
          if ($('.announcement-bar-section').isInViewport()) {
            $(".look:not(.look_stl").css("top", "unset");
          } else {
            $(".look:not(.look_stl").css("top", menu_height);
          }
        }
      });
    }

    if ($(window).width() > 749) {
      if ($('.announcement-bar-section').length) {
        searchModalPosition();
        $(document).on("scroll", function (e) {
          searchModalPosition();
        });
        $(document).on("click", ".close_announcement_bar", function (e) {
          $(".predictive-search").css("height", "90.5dvh");
        });
      }
    }

    function searchModalPosition() {
      if ($('.announcement-bar-section').isInViewport()) {
        $(".predictive-search").css("height", "88dvh");
      } else {
        $(".predictive-search").css("height", "90.5dvh");
      }
    }

    // Popin Omnicanal
    // Ouverture de la popin
    $('.omnicanal-toggle-1, .omnicanal-toggle-2').click(function (ev) {
      ev.preventDefault();

      // get iframe data-barcode attribute in a variable
      var barcode = $('.omnicanal-popin iframe').data("barcode");

      $(".omnicanal-popin iframe").attr("src", $('.omnicanal-popin iframe').data("src") + "&checked=" + barcode);

      $(".omnicanal-popin").fadeIn();
    });

    // Fermeture de la popin
    $('.omnicanal-popin').click(function (e) {
      if ($(e.target).attr("class") == "omnicanal-popin" || $(e.target).hasClass("close") || $(e.target).hasClass("icon")) {
        e.preventDefault();
        $(".omnicanal-popin").fadeOut();
      }
    });

    // FAQ
    // --------------------------------------------
    // Constitution de la liste des thèmes dans l'aside
    $(".faq_theme").each(function () {
      var faq = $(this).attr("id");
      var faq_name = $(this).find(".theme_title").html();
      $(".faq_page aside nav").append("<a data-name='" + faq.toLowerCase() + "'>" + faq_name + "</a>");
      $(".faq_page aside nav a:first-child").addClass("selected");
    });

    // Souligner le thème sélectionné + apparition de la section de questions associée
    $("aside nav a").click(function (e) {
      $("aside nav a").removeClass("selected");
      $(this).addClass("selected");

      $name = $(this).data("name");
      $(".faq_theme").parent(".faq_section").hide();
      $("#" + $name + ".faq_theme").parent(".faq_section").fadeIn(400);
    });

    // Ouverture des questions au clic sur le titre
    $(".faq_list h3, .accordeon_blocks h3").click(function (e) {
      var questions = $(".faq_list h3, .accordeon_blocks h3");
      var answers = $(".faq_list > div, .accordeon_blocks > div");
      $(this).toggleClass("opened");
      if (answers.length) {
        $(questions).not($(this)).removeClass("opened");
        $(questions).not($(this)).next(answers).slideUp();
        $(this).next("div").slideToggle();
      }
    });

    // Accordeon sur CGV et page entretien
    // --------------------------------------------

    $(".accordeon_titles a").on("click", function (e) {
      e.preventDefault();

      const name = $(this).data("name");
      const $this = $("h3#" + name);
      const this_height = $this.next("div").innerHeight(); // conservée

      $this.toggleClass("opened");
      $this.next("div").slideToggle();

      $(".accordeon_theme").not($this).removeClass("opened");
      $(".accordeon_theme").not($this).next("div").slideUp(200);

      setTimeout(function () {
        // scroll to the top of the h3 with the id name
        const offset = $("#" + name).offset().top - 40;
        $("html, body.body-accordeon").animate({ scrollTop: offset });
      }, 300);
    });

    // Au chargement : si une ancre est présente dans l'URL, on ouvre le bon accordeon
    if (window.location.hash) {
      const nameFromHash = window.location.hash.substring(1);
      const $link = $('.accordeon_titles a[data-name="' + nameFromHash + '"]');

      if ($link.length) {
        $link.trigger("click");
      }
    }

    // Page boutique
    // --------------------------------------------

    if ($(".store_features").length) {
      if ($(window).width() >= 750) {
        // Ouverture des onglets détails de la boutique
        $(".tabs p").click(function (e) {
          $(".tabs p").removeClass("selected");
          $(this).addClass("selected");
          $name = $(this).data("name");

          $(".tab").hide();
          $(".tab[data-target='" + $name + "']").fadeIn(400);
        });
      }
    }

    // Panier
    // --------------------------------------------

    // Messages cadeaux
    if ($("#checkbox_message").length) {
      $(document).on('change', '#checkbox_message', function () {
        $('#gift_message_1, #gift_message_2, #gift_message_3, #gift_message_4, #gift_message_5').val('');

        if ($(this).is(":checked")) {
          $(".gift_message_fields").show();
        } else {
          $(".gift_message_fields").hide();
          $('#gift_message_error').hide();
        }

        $('#CartDrawer-Form').on('submit', function (e) {
          if ($('#checkbox_message').is(':checked')) {
            if (
              !$('#gift_message_1').val() &&
              !$('#gift_message_2').val() &&
              !$('#gift_message_3').val() &&
              !$('#gift_message_4').val() &&
              !$('#gift_message_5').val()
            ) {
              e.preventDefault(); // bloque l'envoi
              $('#gift_message_error').show();
              $('#gift_message_error .error-forbidden').hide();
              $('#gift_message_error .error-empty').show();
            }
          }
        });
      });
    }

    $(document).on('input', '[id^="gift_message_"]', function () {
      const forbidden = /[\/'_%&;]/g;

      if (forbidden.test(this.value)) {
        this.value = this.value.replace(forbidden, '');

        $('#gift_message_error').show();
        $('#gift_message_error .error-empty').hide();
        $('#gift_message_error .error-forbidden').show();
      } else {
        $('#gift_message_error .error-forbidden').hide();

        // cache le conteneur si plus aucune erreur visible
        if (!$('#gift_message_error span:visible').length) {
          $('#gift_message_error').hide();
        }
      }
    });

    // Cart upsell
    // --------------------------------------------
    if ($(".cart_upsell").length) {
      $(document).on('click', '.cart_upsell .icon-close', function () {
        $(".cart_upsell").slideUp();
      });
    }

    // Barre d'annonce
    // --------------------------------------------
    // Click sur le bouton de fermeture de la barre
    $('.close_announcement_bar').click(function (e) {
      e.preventDefault();

      // Transition de fermeture
      $('.announcement-bar-section').slideUp(150, function () {
        $(this).remove();
      })

      // On stocke en session la demande de fermeture
      sessionStorage.setItem("closed_announcement", "true");
    });

    // Pages quick links
    // --------------------------------------------

    if ($("body.template_page .quick_links_section").length) {
      $("main").css("margin-top", "0");
    }

    // Swiper init card product + product page
    initSwipers();

    // Connexion compte
    // --------------------------------------------
    $('input#CustomerEmail').keypress(function (e) {
      if (e.which == 13) { // Code 13 correspond à la touche "Entrée"
        e.preventDefault(); // Empêche la soumission du formulaire
        var inputs = $('input'); // Sélectionne tous les champs input
        var index = inputs.index(this); // Trouve l'index du champ actuel
        if (index < inputs.length - 1) {
            inputs.eq(index + 1).focus(); // Déplace le focus au champ suivant
        }
      }
    });

    // Section vidéo avec controles manuels
    $('.video_controls').each(function () {
      const $controls = $(this);
      const $block = $controls.closest('.column');

      function getCurrentVideo() {
        if ($(window).width() <= 749) {
          return $block.find('video.responsive').get(0) || null;
        } else {
          return $block.find('video.desktop').get(0) || null;
        }
      }

      $controls.find('.play').on('click', function () {
        const video = getCurrentVideo();
        if (video) video.play();
      });

      $controls.find('.pause').on('click', function () {
        const video = getCurrentVideo();
        if (video) video.pause();
      });

      $controls.find('.mute').on('click', function () {
        const video = getCurrentVideo();
        if (!video) return;

        video.muted = !video.muted;

        // Toggle icons
        const $muteIcon = $(this).find('.icon-mute');
        const $unmuteIcon = $(this).find('.icon-unmute');

        if (video.muted) {
          $muteIcon.hide();
          $unmuteIcon.show();
        } else {
          $muteIcon.show();
          $unmuteIcon.hide();
        }
      });
    });

  });
})(jQuery);

// Swipers des cartes produit : initialisation à la demande
// --------------------------------------------
// Chaque carte est un Web component <card-product> (cf. snippets card-product,
// card-product-alt, depict-card-product) : son connectedCallback enregistre son
// Swiper dès qu'elle entre dans le DOM, que ce soit au rendu initial, après un
// filtre (facets.js), une pagination Depict ou une reco Potions. Plus besoin de
// MutationObserver sur #product-grid ni de ré-appel global après chaque rendu.
//
// Chaque `new Swiper()` écrit des styles puis relit les dimensions de la carte,
// ce qui force un layout complet du document. Sur une PLP de 54 cartes dans un
// DOM de 8 000 nœuds, l'ancienne boucle synchrone coûtait ~3 s de thread
// principal bloqué au chargement (mesuré en prod le 2026-09-15), d'où l'INP
// dégradé sur le gabarit collection. On n'instancie donc un Swiper que quand
// sa carte approche du viewport, un par frame, plus une init immédiate au
// premier pointerdown si l'utilisateur touche une carte avant son tour.
//
// L'affichage des tailles au survol (ex showProductSizes) est géré en CSS,
// cf. styles/_collection.scss (.card__inner:hover + .card__content:has(...)).

var CARD_SWIPER_QUEUED_ATTR = "data-swiper-queued";
var cardSwiperQueue = [];
var cardSwiperDrainScheduled = false;
var cardSwiperObserver = null;

function buildCardSwiper(el) {
  if (!el || el.classList.contains("swiper-initialized")) return;
  el.removeAttribute(CARD_SWIPER_QUEUED_ATTR);
  if (cardSwiperObserver) cardSwiperObserver.unobserve(el);
  // Dans une section slider-component (slider horizontal), le slider parent
  // garde le geste tactile : sinon le Swiper de la carte pose
  // touch-action:pan-y, capte le swipe horizontal et empêche de scroller le
  // slider parent (double scroll). On initialise quand même le Swiper, mais
  // sans allowTouchMove : la navigation se fait alors aux flèches.
  var inSlider = !!el.closest("slider-component");
  // Sélecteurs scopés à la carte : avec des sélecteurs globaux, chaque
  // instance interrogeait tout le document (82 boutons) avant de se rabattre
  // sur les siens.
  new Swiper(el, {
    loop: true,
    allowTouchMove: !inSlider,
    navigation: {
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      hide: false,
    },
  });
}

// Enregistre le Swiper d'une carte pour une init différée (viewport + file).
function registerCardSwiper(el) {
  if (!el || el.classList.contains("swiper-initialized") || el.hasAttribute(CARD_SWIPER_QUEUED_ATTR)) return;
  el.setAttribute(CARD_SWIPER_QUEUED_ATTR, "");
  var observer = getCardSwiperObserver();
  if (observer) {
    observer.observe(el);
  } else {
    enqueueCardSwiper(el);
  }
}

// Vide la file un Swiper par frame : chaque init reste une tâche courte et
// laisse le navigateur traiter les interactions entre deux cartes.
function drainCardSwiperQueue() {
  cardSwiperDrainScheduled = false;
  var el = cardSwiperQueue.shift();
  while (el && (el.classList.contains("swiper-initialized") || !el.isConnected)) {
    el = cardSwiperQueue.shift();
  }
  if (!el) return;
  buildCardSwiper(el);
  if (cardSwiperQueue.length) scheduleCardSwiperDrain();
}

function scheduleCardSwiperDrain() {
  if (cardSwiperDrainScheduled) return;
  cardSwiperDrainScheduled = true;
  window.requestAnimationFrame(drainCardSwiperQueue);
}

function enqueueCardSwiper(el) {
  if (cardSwiperQueue.indexOf(el) === -1) cardSwiperQueue.push(el);
  scheduleCardSwiperDrain();
}

function getCardSwiperObserver() {
  if (cardSwiperObserver || !("IntersectionObserver" in window)) return cardSwiperObserver;
  cardSwiperObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cardSwiperObserver.unobserve(entry.target);
        enqueueCardSwiper(entry.target);
      });
    },
    // Marge généreuse : la carte est prête avant d'entrer dans l'écran.
    { rootMargin: "300px 0px" }
  );
  return cardSwiperObserver;
}

// Balayage global : filet pour les .mySwiper hors <card-product> (anciens
// snippets, HTML injecté par une app) et init du slider produit mobile.
function initSwipers() {
  var targets = document.querySelectorAll(
    ".mySwiper:not(.swiper-initialized):not([" + CARD_SWIPER_QUEUED_ATTR + "])"
  );
  Array.prototype.forEach.call(targets, registerCardSwiper);

  if ($(".product_swiper").length && $(window).width() < 750) {
    var swiper_product = new Swiper(".product_swiper", {
      loop: true,
      centeredSlides: true,
      spaceBetween: 8,
      slidesPerView: "auto"
    });
    swiper_product.slideToLoop(0, 0);
  }
}

// Conservé pour compatibilité : l'init est désormais toujours différée.
function initSwipersLazy() {
  initSwipers();
}

// Filet de sécurité : si l'utilisateur touche une carte dont le Swiper n'est
// pas encore instancié (scroll très rapide, ancre en bas de page), on
// l'initialise immédiatement pour que le geste soit pris en compte.
document.addEventListener(
  "pointerdown",
  function (event) {
    var el = event.target && event.target.closest && event.target.closest(".mySwiper");
    if (!el || el.classList.contains("swiper-initialized")) return;
    buildCardSwiper(el);
  },
  { capture: true, passive: true }
);

// Web component <card-product> : chaque carte enregistre son Swiper à
// l'insertion dans le DOM. Défini après les fonctions ci-dessus car
// customElements.define upgrade immédiatement les cartes déjà présentes.
if (window.customElements && !customElements.get("card-product")) {
  class CardProduct extends HTMLElement {
    connectedCallback() {
      var swiperEl = this.querySelector(".mySwiper");
      if (swiperEl) registerCardSwiper(swiperEl);
    }
  }
  customElements.define("card-product", CardProduct);
}

function initURLTarget() {
  document.querySelectorAll("[data-url_target]").forEach(element => {
    element.addEventListener("click", () => {
      const url = element.dataset.url_target;
      if (url && url !== "#") {
        window.location.href = url;
      }
    });
  });
}
